import React from "react";

import { CompareFeatureBlock } from "@reactivated";

import { Image } from "../../../common/Image";
import { RichText } from "../../../common/RichText";

import styles from "./CompareFeatureRow.module.scss";

interface IProps {
    feature: CompareFeatureBlock;
    content: (CompareFeatureBlock | null)[] | undefined;
}

export const CompareFeatureRow = (props: IProps) => {
    if (!props.content) {
        return null;
    }
    return (
        <div className={styles.compareFeatureRowContainer}>
            {props.content.map(
                (item) =>
                    item?.icon &&
                    item?.feature && (
                        <div
                            key={item.icon.title}
                            className={styles.contentContainer}
                        >
                            <Image
                                src={item.icon.url}
                                alt={item.feature.title}
                                className={styles.icon}
                            />
                            <RichText html={item?.description || ""} />
                        </div>
                    ),
            )}
        </div>
    );
};
